/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartPieA2Icon64Regular = forwardRef('DataChartPieA2Icon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M33.562 6.022C32.117 5.962 31 7.137 31 8.5v22a2.5 2.5 0 0 0 2.5 2.5h22c1.363 0 2.538-1.117 2.478-2.562A25.498 25.498 0 0 0 33.562 6.022ZM34 30V9.05A22.5 22.5 0 0 1 54.95 30H34Z" }),
        React.createElement("path", { d: "M24.964 10.103a1.5 1.5 0 0 0-.918-2.856 26 26 0 1 0 32.691 32.758 1.5 1.5 0 1 0-2.854-.924 23.001 23.001 0 1 1-28.92-28.978Z" })));
});
